import React, { useEffect, useState } from "react";
import { Box, Popover, Tooltip, alpha, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import EmojiPicker from "../../../components/MessageHistory/EmojiPicker";
import { TEAM_QUICK_REACTIONS } from "../utils/teamMessageUtils";

const reactionEmojiButtonSx = {
  border: "none",
  background: "transparent",
  cursor: "pointer",
  fontSize: "1.5rem",
  lineHeight: 1,
  p: 0.65,
  borderRadius: 2,
  opacity: 1,
  color: "inherit",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontFamily: '"Segoe UI Emoji", "Apple Color Emoji", "Noto Color Emoji", sans-serif',
  transition: "transform 0.12s ease, background-color 0.12s ease",
  "&:hover": {
    bgcolor: "action.hover",
    transform: "scale(1.12)",
  },
};

const TeamReactionPicker = ({ anchorEl, open, onClose, onSelectEmoji }) => {
  const { t } = useTranslation("team");
  const theme = useTheme();
  const [showFullPicker, setShowFullPicker] = useState(false);

  useEffect(() => {
    if (!open) setShowFullPicker(false);
  }, [open]);

  const handleSelect = (emoji) => {
    onSelectEmoji?.(emoji);
    onClose?.();
  };

  const handleClose = () => {
    setShowFullPicker(false);
    onClose?.();
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      transformOrigin={{ vertical: "bottom", horizontal: "center" }}
      slotProps={{
        paper: {
          sx: {
            borderRadius: 3,
            boxShadow: `0 4px 16px ${alpha(theme.palette.common.black, 0.14)}`,
            border: "none",
            overflow: "hidden",
            bgcolor: "background.paper",
          },
        },
      }}
    >
      {showFullPicker ? (
        <EmojiPicker onSelectEmoji={handleSelect} />
      ) : (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.15,
            p: 0.75,
            bgcolor: "background.paper",
          }}
        >
          {TEAM_QUICK_REACTIONS.map((emoji) => (
            <Tooltip key={emoji} title={emoji} placement="top">
              <Box
                component="button"
                type="button"
                onClick={() => handleSelect(emoji)}
                sx={reactionEmojiButtonSx}
                aria-label={emoji}
              >
                {emoji}
              </Box>
            </Tooltip>
          ))}
          <Tooltip title={t("reactionMoreEmojis")} placement="top">
            <Box
              component="button"
              type="button"
              onClick={() => setShowFullPicker(true)}
              sx={{
                ...reactionEmojiButtonSx,
                fontSize: "1.35rem",
                fontWeight: 700,
                color: "text.secondary",
                minWidth: 36,
              }}
              aria-label={t("reactionMoreEmojis")}
            >
              +
            </Box>
          </Tooltip>
        </Box>
      )}
    </Popover>
  );
};

export default TeamReactionPicker;
